import { fetch } from "./API";

export const FetchTfsSrpYearRates = async (query: {} | undefined) => {
  try {
    return await fetch(
      `${process.env.REACT_APP_API_URL}/tfs-srp-year-rates`,
      { ...query }
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
